export enum CART_ITEM_ID {
  FREE_BAGS = "freeBags",
  EXTRA_BAGS = "extraBags",
  EXTRA_BAGS20 = "extraBags20",
  ADMIN_FEE = "adminFee",
  AM_PLUS_SEATS = "amPlusSeats",
  AM_PREFERRED_SEATS = "amPreferredSeats",
  FIRST_CLASS_SEATS = "firstClassSeats",
  COACH_SEATS = "coachSeats",
  SEAT = "seat",
  PREMIERE_SEAT_UPGRADE = "PREMIERE_SEAT_UPGRADE",
  EXTRA_WEIGHT = "EXTRA_WEIGHT",
  SEAT_SELECTION_FEE = "seatSelectionFee",
  CARRY_ON = "CARRY_ON"
}

export enum TYPE_CART_PURCHARSE{
  ONLY_BAGS= 1,
  EXTRA_WEIGHT,
  EXTRA_WEIGHT_CARRY_ON,
  ONLY_SEATS,
  SEATS_AND_BAGS,
  WITHOUT_CHECKIN
}

export enum OPERATION_PAY{
  CHECKIN = 'CHECKIN',
  EXTRA_WEIGHT = 'EXTRAWEIGHT',
  UPGRADE = 'UPGRADE'
}
